import userService from 'resources/user/user.service';
import * as userApi from 'resources/user/user.api';


export const sendInvitation = async ({ id, shouldSendEmail, shouldSendSms }) => {
  let response = await userApi.invite({ id, shouldSendEmail, shouldSendSms });

  return response;
};

export const resendInvitation = async ({ id, shouldSendEmail, shouldSendSms }) => {
  const client = await userService.findById(id);

  if (!client) {
    return null;
  }

  const response = await sendInvitation({ id, shouldSendEmail, shouldSendSms });

  return response;
};
